import { render, staticRenderFns } from "./iadelistesi.vue?vue&type=template&id=43bba65a&"
import script from "./iadelistesi.vue?vue&type=script&lang=js&"
export * from "./iadelistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports